import { createRouter, createWebHistory } from 'vue-router'

import AdminLayout     from '@/components/AdminLayout.vue'

import HomePage          from '@/components/HomePage.vue'
import PrivacyPolicy     from '@/components/PrivacyPolicy.vue'
import TermsConditions   from '@/components/TermsConditions.vue'
import AdminLogin        from '@/components/AdminLogin.vue'
import AdminDashboard    from '@/components/AdminDashboard.vue'
import NewsList          from '@/components/NewsList.vue'
import ConsultancyForm   from '@/components/ConsultancyForm.vue'
import ClientLogin       from '@/components/ClientLogin.vue'
import ClientRegister    from '@/components/ClientRegister.vue'
import ClientDashboard   from '@/components/ClientDashboard.vue'
import NoilePraguri      from '@/components/NoilePraguri.vue'
import DosarulAchizitiei from '@/components/DosarulAchizitiei.vue'
import ContestatiiPage   from '@/components/ContestatiiPage.vue'
import GarantieParticipare from '@/components/GarantieParticipare.vue'
import OuG45             from '@/components/OuG45.vue'
import SeapVsSicap       from '@/components/SeapVsSicap.vue'
import AtestatExpert     from '@/components/AtestatExpert.vue'
import LegislatiePage    from '@/components/LegislatiePage.vue'

const routes = [
  // ── Publice ──────────────────────────────────────────────
  { path: '/',                               component: HomePage },
  { path: '/confidentialitate',              component: PrivacyPolicy },
  { path: '/termeni',                        component: TermsConditions },
  { path: '/stiri',                          component: NewsList },
  { path: '/contact',                        component: ConsultancyForm },

  // ── Consultanță ──────────────────────────────────────────
  { path: '/consultanta/noile-praguri',      component: NoilePraguri },
  { path: '/consultanta/dosarul-achizitiei', component: DosarulAchizitiei },
  { path: '/consultanta/contestatii',        component: ContestatiiPage },
  { path: '/consultanta/garantie-participare', component: GarantieParticipare },
  { path: '/consultanta/oug45',              component: OuG45 },
  { path: '/consultanta/seap-vs-sicap',      component: SeapVsSicap },
  { path: '/consultanta/atestat-expert',     component: AtestatExpert },
  { path: '/consultanta/legislatie',         component: LegislatiePage },

  // ── Client ────────────────────────────────────────────────
  { path: '/client/login',    component: ClientLogin },
  { path: '/client/register', component: ClientRegister },
  {
    path: '/client/dashboard',
    component: ClientDashboard,
    meta: { requiresClient: true },
  },

  // ── Admin (fără header/footer) ────────────────────────────
  {
    path: '/admin',
    component: AdminLayout,
    children: [
      { path: 'login',     component: AdminLogin },
      {
        path: 'dashboard',
        component: AdminDashboard,
        meta: { requiresAdmin: true },
      },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 }
  },
})

router.beforeEach((to, from, next) => {
  const isAdmin  = localStorage.getItem('admin_token') === 'admin_fake_token'
  const isClient = !!localStorage.getItem('client_id')

  if (to.meta.requiresAdmin && !isAdmin)   return next('/admin/login')
  if (to.meta.requiresClient && !isClient) return next('/client/login')

  next()
})

export default router